<template>
  <div>
    <!-- HOW IT WORKS -->
    <section>
      <div class="hiw">
        <div class="howitworks-img text-center">
          <img src="@/assets/img/svg/howitworks.svg" class="img-fluid" />
        </div>

        <div class="zig-zag-b1 d-none d-md-block">
          <div class="col-6 mb-5">
            <div class="content">
              <div class="box-zzb1">
                <div class="borders"></div>
              </div>
              <div class="box2-zzb1">
                <div class="borders2"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="h-box d-block d-md-none"></div>

        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <div class="title">1. Create your event</div>

              <div class="desc-1 float-right">
                Create a special screening for any movie listed on Create
                Screening list and create an event. Step 2 is simple. All you
                have to do is select the movie, cinema, date and time from the
                options available.
              </div>
            </div>
            <div class="col-md-6 pr-0 d-none d-md-block">
              <div class="float-right">
                <img src="@/assets/img/hiw/mac1.png" class="img-fluid" />
              </div>
            </div>

            <div class="col-md-6 mt-2 my-md-0 pr-0 d-block d-md-none">
              <div class="float-right">
                <img src="@/assets/img/hiw/mac1.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>

        <div class="zig-zag-b2 d-none d-md-block">
          <div class="col-md-6 mb-5">
            <div class="content">
              <div class="box-zzb2">
                <div class="borders"></div>
              </div>
            </div>
            <div class="box2-zzb2">
              <div class="borderss2"></div>
            </div>
          </div>
        </div>

        <div class="h-box d-block d-md-none"></div>

        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 pl-0 d-none d-md-block">
              <div>
                <img src="@/assets/img/hiw/mac2.png" class="img-fluid" />
              </div>
            </div>

            <div class="col-md-6">
              <div class="title">2. Set an event type</div>

              <div class="desc-1 float-left">
                We understand that our customers can have multiple ways they’d
                like to catch up on their favorite movies. Small groups or even
                large… and at times the entire cinema! Choose the Screening
                type:
                <div class="mt-3">- Crowdsourced Screening</div>
                <div class="my-1">- Confirmed Screening</div>
                <div class="my-1">- Private Screening</div>
              </div>
            </div>

            <div class="col-md-6 mt-2 my-md-0 pl-0 d-block d-md-none">
              <div class="img-sm">
                <img src="@/assets/img/hiw/mac2.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>

        <div class="zig-zag-b3 d-none d-md-block">
          <div class="col-md-6 mb-5">
            <div class="content">
              <div class="box-zzb3">
                <div class="borders"></div>
              </div>
              <div class="box2-zzb3">
                <div class="bordersss2"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="h-box d-block d-md-none"></div>

        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <div class="title">3. Choose Your Seat & Pay</div>

              <div class="desc-1 float-right">
                Just like any other regular movie booking choose your preferred
                seats and proceed to pay with multiple payment options we’ve
                provided!
                <ul class="list-unstyled mt-3"></ul>
              </div>
            </div>
            <div class="col-md-6 pr-0 d-none d-md-block">
              <div class="float-right">
                <img src="@/assets/img/hiw/mac3.png" class="img-fluid" />
              </div>
            </div>

            <div class="col-md-6 mt-2 my-md-0 pr-0 d-block d-md-none">
              <div class="float-right img-sm">
                <img src="@/assets/img/hiw/mac3.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>

        <div class="zig-zag-b4 d-none d-md-block">
          <div class="col-6 mb-5">
            <div class="content">
              <div class="box-zzb4">
                <div class="borders"></div>
              </div>
              <div class="box2-zzb4">
                <div class="borderssss2"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="h-box d-block d-md-none"></div>

        <div class="container-fluid">
          <div class="title">4. Wait for your event to get confirmed</div>
          <div class="desc-box">
            <div class="desc">
              Each screening and cinema have a very specific number of minimum
              number of seats that have to be sold for the movie to be
              confirmed. So make sure you tell your friends and family and
              anyone everyone you know who’d love to watch your favourite movie
              with you.
            </div>
          </div>

          <div class="container ticket-box text-center mt-5">
            <img src="@/assets/img/hiw/mac4.png" class="img-fluid" />
          </div>

          <div class="mt-4 mb-4 dash-line"></div>

          <div class="title">EVENT CONFIRMED!</div>
          <div class="desc">Perfect...Off you go!</div>

          <div class="w-75 mx-auto my-3">
            <img
              src="@/assets/img/gogo-people.png"
              class="img-fluid mx-auto d-block"
            />
          </div>

          <!-- <div class="text-center py-5">
     <router-link to="/"><button class="btn btn-danger gogo-cus-btn">Browse Movies</button></router-link>
          </div>-->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "howItsWorks",

  data() {
    return {};
  }
};
</script>

<style>
/*how it works*/

.hiw .title {
  color: #8d99af;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  letter-spacing: -1px;
}

.hiw .desc-box {
  width: 30%;
  margin: 0 auto;
  text-align: justify;
  margin-bottom: 20px;
}

.hiw .ticket {
  width: 380px;
  height: 60%;
  margin: 0 auto;
  border-radius: 14px;
  border: 2px solid #ddd;
}

.hiw .ticket .container {
  border-radius: 10px;
  border-top: 2px solid #ddd;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.hiw .desc {
  color: #2b2d42;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
}

.hiw {
  width: 100%;
  user-select: none;
  height: 100%;
  background-size: cover !important;
  background-repeat: repeat !important;
  background-attachment: fixed !important;
  background: url(../../assets/img/svg/gogo-bg.svg);
}

.hiw .doodle1 {
  background: url(../../assets/img/svg/doodle1.svg);
  width: 100%;
  height: 135px;
  background-position: right !important;
  background-repeat: no-repeat !important;
}

.hiw .doodle2 {
  background: url(../../assets/img/svg/doodle2.svg);
  width: 100%;
  height: 135px;
  background-position: left !important;
  background-repeat: no-repeat !important;
}

.hiw .vector-1 {
  background: url(../../assets/img/svg/hiw1.svg);
  height: 50px;
  width: 100%;
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

.hiw .confirmed-screening {
  height: auto;
  width: 100%;
  display: block;
  margin: 0 auto;
}

.hiw .desc-1 {
  width: 50%;
  margin: 0 auto;
  text-align: left;
}

.hiw .desc-2 {
  width: 50%;
}

.hiw .line-center {
  border-right: 2px solid grey;
  height: 80px;
  border-bottom: 2px solid grey;
  border-bottom-right-radius: 20px;
}

.hiw .zig-zag-b1 {
  position: relative;
}

.hiw .zig-zag-b1 .box-zzb1 {
  position: absolute;
  left: 58%;
}

.hiw .zig-zag-b1 .box-zzb1 {
  position: relative;
}

.hiw .zig-zag-b1 .box-zzb1 .borders {
  width: 45%;
  height: 90px;
  border-bottom: 2.5px solid #ddd;
  border-right: 2.5px solid #ddd;
  border-bottom-right-radius: 30px;
}

.hiw .box2-zzb1 .borders2 {
  position: absolute;
  top: 98%;
  right: 19%;
}

.hiw .box2-zzb1 .borders2 {
  width: 30%;
  height: 50px;
  border-top: 2.5px solid #ddd;
  border-left: 2.5px solid #ddd;
  border-top-left-radius: 30px;
  margin-top: -1px;
}

/*zig-zag-b2 border after 1 column*/
.hiw .zig-zag-b2 {
  position: relative;
}

.hiw .zig-zag-b2 .box-zzb2 {
  position: absolute;
  left: 50%;
}

.hiw .zig-zag-b2 .box-zzb2 {
  position: relative;
}

.hiw .zig-zag-b2 .box-zzb2 .borders {
  width: 90%;
  height: 80px;
  border-bottom: 2.5px solid #ddd;
  border-left: 2.5px solid #ddd;
  border-bottom-left-radius: 30px;
  margin-top: -1px;
}

.hiw .zig-zag-b2 .box2-zzb2 .borderss2 {
  position: absolute;
  top: 98%;
  left: 120%;
}

.hiw .zig-zag-b2 .box2-zzb2 .borderss2 {
  width: 30%;
  height: 50px;
  border-top: 2.5px solid #ddd;
  border-right: 2.5px solid #ddd;
  border-top-right-radius: 30px;
  margin-top: -1px;
}

/*zig-zag-b2 border after 2 column*/
.hiw .zig-zag-b3 {
  position: relative;
}

.hiw .zig-zag-b3 .box-zzb3 {
  position: absolute;
  left: 64%;
}

.hiw .zig-zag-b3 .box-zzb3 {
  position: relative;
}

.hiw .zig-zag-b3 .box-zzb3 .borders {
  width: 90%;
  height: 80px;
  border-bottom: 2.5px solid #ddd;
  border-right: 2.5px solid #ddd;
  border-bottom-right-radius: 30px;
}

.hiw .zig-zag-b3 .box2-zzb3 .bordersss2 {
  position: absolute;
  top: 98%;
  right: 20%;
}

.hiw .zig-zag-b3 .box2-zzb3 .bordersss2 {
  width: 30%;
  height: 50px;
  border-top: 2.5px solid #ddd;
  border-left: 2.5px solid #ddd;
  border-top-left-radius: 30px;
  margin-top: -1px;
}

/*zig-zag-4b after 3*/
.hiw .zig-zag-b4 {
  position: relative;
}

.hiw .zig-zag-b4 .box-zzb4 {
  position: absolute;
  left: 49%;
}

.hiw .zig-zag-b4 .box-zzb4 {
  position: relative;
}

.hiw .zig-zag-b4 .box-zzb4 .borders {
  width: 41%;
  height: 90px;
  border-bottom: 2.5px solid #ddd;
  border-left: 2.5px solid #ddd;
  border-bottom-left-radius: 30px;
}

.hiw .box2-zzb4 .borderssss2 {
  position: absolute;
  top: 98%;
  left: 67%;
}

.hiw .box2-zzb4 .borderssss2 {
  width: 30%;
  height: 50px;
  border-top: 2.5px solid #ddd;
  border-right: 2.5px solid #ddd;
  border-top-right-radius: 30px;
  margin-top: -1px;
}

/*ticket*/
.ticket {
  background-color: #e6eaf2;
}

/*green-dash*/

.hiw .green-dash span {
  display: block;
  margin: 0 auto;
  background-color: green;
  width: 100%;
  height: 20px;
  border-radius: 20px;
}

.hiw .h-box {
  border-left: 2.5px solid #ddd;
  height: 100px;
  margin-left: 50%;
}

.hiw .img-sm {
  height: auto;
  width: 90%;
}

.hiw .dash-line {
  border-left: 2.5px solid #ddd;
  height: 90px;
  margin-left: 50%;
}

/*how it works-end*/

/* responsive hiw */

@media (max-width: 767px) {
  .hiw .desc-1 {
    width: 100% !important;
    margin: 0 auto;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/howItsWorks.vue